// 인디피아 앱 설치 착지 페이지 — 랜딩 헤더 "앱 설치" 버튼의 딥링크 폴백.
//
// 앱설치 버튼은 https://{host}/u/app 으로 보낸다. 앱이 설치+App Links 검증된 단말이면
// OS 가 이 경로를 가로채 앱이 직접 열리므로, 이 페이지에 닿았다는 것은 "미설치" 라는 뜻이다.
// (idpMobile AndroidManifest 의 autoVerify App Links: scheme=https host={appLinkHost} pathPrefix=/u/)
//
// 인증·API 호출이 없는 공개 경로다. landing.css 의 --lp-* 변수는 .lp 스코프 밖이라 여기선 못 쓴다 —
// AppInstallGuidePage 규약과 동일하게 명시 색상으로 그린다.
//
// 미출시(앱 마켓 등록 전) 단계이므로 스토어 이동은 APP_RELEASED 플래그로 막아 둔다.
// 출시되면 APP_RELEASED=true 로 바꾸면 Play 스토어 버튼이 활성화된다.

import { detectPlatform } from '../lib/platform';

// 앱 마켓 출시 여부 — 출시 시 true 로 바꾸면 스토어 버튼이 열린다(그 전까지 "준비 중").
const APP_RELEASED = false;
const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=ai.indipia.app';

export function AppLandingPage() {
  const platform = detectPlatform();
  const showStore = APP_RELEASED && platform === 'android';

  const pageStyle: React.CSSProperties = {
    minHeight: '100vh',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 20,
    padding: '32px 24px',
    background: 'var(--shell-bg)',
    color: 'var(--shell-on-surface)',
    fontFamily: 'system-ui, -apple-system, "Segoe UI", Roboto, "Noto Sans KR", sans-serif',
  };

  const cardStyle: React.CSSProperties = {
    width: '100%',
    maxWidth: 420,
    boxSizing: 'border-box',
    background: 'var(--shell-surface)',
    border: '1.5px solid var(--shell-border)',
    borderRadius: 16,
    padding: '32px 24px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 14,
    boxShadow: '0 6px 24px var(--alpha-black-50)',
  };

  const noticeStyle: React.CSSProperties = {
    marginTop: 6,
    width: '100%',
    boxSizing: 'border-box',
    padding: '14px 18px',
    borderRadius: 12,
    background: 'var(--shell-bg)',
    border: '1.5px solid var(--shell-border)',
    fontSize: 13.5,
    color: 'var(--shell-on-surface-2)',
    lineHeight: 1.7,
    textAlign: 'center',
  };

  return (
    <div style={pageStyle}>
      <div style={cardStyle}>
        <div
          style={{
            width: 56, height: 56, borderRadius: 14, background: 'var(--indipia-purple-50)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}
        >
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="var(--indipia-purple-600)" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <rect x="5" y="2" width="14" height="20" rx="2" /><line x1="12" y1="18" x2="12.01" y2="18" />
          </svg>
        </div>

        <div style={{ fontSize: 18, fontWeight: 800, letterSpacing: '-0.5px', textAlign: 'center' }}>
          인디피아 앱
        </div>

        <div style={{ fontSize: 14, color: 'var(--shell-on-surface-2)', lineHeight: 1.7, textAlign: 'center' }}>
          현장 사진 정리부터 공사 현황까지
          <br />
          휴대폰에서 바로 관리할 수 있습니다
        </div>

        {showStore && (
          <a
            href={PLAY_STORE_URL}
            style={{
              marginTop: 6, width: '100%', boxSizing: 'border-box',
              display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 8,
              padding: '14px 20px', borderRadius: 12,
              background: 'var(--indipia-purple-600)', color: 'var(--gray-0)',
              fontSize: 15, fontWeight: 700, textDecoration: 'none',
            }}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="7 10 12 15 17 10" /><line x1="12" y1="15" x2="12" y2="3" />
            </svg>
            Play 스토어에서 설치
          </a>
        )}

        {!showStore && (
          <div style={noticeStyle}>
            앱을 준비하고 있습니다.
            <br />
            정식 출시 전까지 조금만 기다려 주세요.
          </div>
        )}
      </div>
    </div>
  );
}
